import {directive as vClickOutside} from "vue-clickaway";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */
const GlobalDirectives = {
	install(Vue) {
		Vue.directive("click-outside", vClickOutside);

		// Custom directive to change visibility, similar to v-show, but based on CSS attribute "visibility".
		// This keeps the element's space occupied in the layout even if hidden.
		Vue.directive("visible", {
			bind(el, binding) {
				el.style.visibility = binding.value ? "visible" : "hidden";
			},
			update(el, binding) {
				if (binding.value !== binding.oldValue) {
					el.style.visibility = binding.value ? "visible" : "hidden";
				}
			}
		});
	}
};

export default GlobalDirectives;